module.exports = __webpack_public_path__ + "img/Paper_1_10.70300870.png";